import React from 'react';
import LazyRenderWrapper from 'UI/components/molecules/LazyRenderWrapper';
import { getSpecialtyDetails } from 'UI/components/molecules/MapEntityInfo/MapEntityInfo.utils';
import MapInventoryCard from 'UI/components/molecules/MapInventoryItem/MapInventoryItem';

import { getEntityProps } from './EntityResultsList.utils';

/**
 * @param {Object} props
 * @param {Array<Object>} props.results
 * @param {string} props.entity
 */

export const EntityResultsList = ({ results, entity }) => {
  return (
    <>
      {results.map(item => {
        const specialtyDetails = getSpecialtyDetails(item);
        const entityProps = getEntityProps({ entity, item, specialtyDetails });

        if (!entityProps) return null;

        return (
          <LazyRenderWrapper component="li" key={item.id}>
            <MapInventoryCard entityProps={entityProps} entity={entity} info={item} />
          </LazyRenderWrapper>
        );
      })}
    </>
  );
};
